"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    anchorEnum: function() {
        return anchorEnum;
    },
    default: function() {
        return createKonvaTransformer;
    }
});
const _konva = /*#__PURE__*/ _interop_require_default(require("konva"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const anchorEnum = Object.freeze({
    // TOP
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    // MIDDLE
    TOP_CENTER: "top-center",
    MIDDLE_RIGHT: "middle-right",
    MIDDLE_LEFT: "middle-left",
    BOTTOM_CENTER: "bottom-center",
    // BOTTOM
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right"
});
function createKonvaTransformer(config = {}) {
    var tr = new _konva.default.Transformer(_object_spread({
        enabledAnchors: Object.values(anchorEnum),
        // custom handles -->
        anchorStyleFunc: (anchor)=>{
            // anchor is Konva.Rect instance
            // you manually change its styling
            anchor.cornerRadius(10);
            if (anchor.hasName(anchorEnum.TOP_CENTER) || anchor.hasName(anchorEnum.BOTTOM_CENTER)) {
                anchor.height(6);
                anchor.offsetY(3);
                anchor.width(30);
                anchor.offsetX(15);
            }
            if (anchor.hasName(anchorEnum.MIDDLE_LEFT) || anchor.hasName(anchorEnum.MIDDLE_RIGHT)) {
                anchor.height(30);
                anchor.offsetY(15);
                anchor.width(6);
                anchor.offsetX(3);
            }
        }
    }, config));
    return tr;
}
